export default __webpack_public_path__ + "static/media/Group 11909.4d665f34.svg";